import React, { useEffect } from 'react';
import {
  SearchInput,
  Facets,
  ViewSwitcher,
} from '@plone/volto/components/manage/Blocks/Search/components';
import FilterList from './FilterList';
import { Grid, Segment, Button } from 'semantic-ui-react';
import { flushSync } from 'react-dom';
import { defineMessages, useIntl } from 'react-intl';
import cx from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
// import { getVocabulary } from '@plone/volto/actions/vocabularies/vocabularies';
import { getVocabulary } from '../../../actions/vocabularies/vocabularies';
// import { getQuerystring } from '@plone/volto/actions/querystring/querystring';
import { getQuerystring } from '../../../actions/querystring/querystring';

const messages = defineMessages({
  searchButtonText: {
    id: 'Search',
    defaultMessage: 'Search',
  },
});

const FacetWrapper = ({ children, facetSettings = {}, visible, ...rest }) => {
  const { advanced, field = {} } = facetSettings;
  const dispatch = useDispatch();
  const { locale } = useSelector((state) => state.intl);
  useEffect(() => {
    dispatch(
      getVocabulary({
        vocabNameOrURL: 'collective.taxonomy.companytype',
        size: 200,
        locale,
      }),
    );
    dispatch(
      getVocabulary({
        vocabNameOrURL: 'fbc.addon.CountryVocabulary',
        size: 200,
        locale,
      }),
    );
  }, [dispatch, locale]);

  return (
    <Segment
      basic
      className={cx('facet', {
        [`facet-index-${field.value}`]: !!field.value,
        'advanced-facet': advanced,
        'advanced-facet-hidden': !visible,
      })}
    >
      {children}
    </Segment>
  );
};

const LeftColumnFacets = (props) => {
  const {
    children,
    data,
    // totalItems,
    facets,
    setFacets,
    // setSortOn,
    // setSortOrder,
    // sortOn,
    // sortOrder,
    onTriggerSearch,
    searchedText, // search text for previous search
    searchText, // search text currently being entered (controlled input)
    isEditMode,
    querystring = {},
    // searchData,
    // mode = 'view',
    // variation,
  } = props;
  const { locale } = useSelector((state) => state.intl);
  const { showSearchButton } = data;
  const isLive = !showSearchButton;
  const intl = useIntl();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getQuerystring(locale));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid className="searchBlock-facets left-column-facets" stackable>
      {data.headline && (
        <>
          <Grid.Row className="centered">
            <Grid.Column>
              <h1 className="headline">{data.headline}</h1>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row className="centered">
            <Grid.Column>
              {(Object.keys(data).includes('showSearchInput')
                ? data.showSearchInput
                : true) && (
                <div className="search-wrapper">
                  <SearchInput {...props} isLive={isLive} />
                  {data.showSearchButton && (
                    <Button primary onClick={() => onTriggerSearch(searchText)}>
                      {data.searchButtonLabel ||
                        intl.formatMessage(messages.searchButtonText)}
                    </Button>
                  )}
                </div>
              )}
            </Grid.Column>
          </Grid.Row>
        </>
      )}

      <Grid.Row className="content-row">
        {data.facets?.length > 0 && (
          <Grid.Column mobile={12} tablet={4} computer={3}>
            <div className="facets">
              {data.facetsTitle && <h3>{data.facetsTitle}</h3>}
              <Facets
                querystring={querystring}
                data={data}
                facets={facets}
                setFacets={(f) => {
                  flushSync(() => {
                    setFacets(f);
                    onTriggerSearch(searchedText || '', f);
                  });
                }}
                facetWrapper={FacetWrapper}
              />
            </div>
          </Grid.Column>
        )}

        <Grid.Column
          mobile={12}
          tablet={data.facets?.length ? 8 : 12}
          computer={data.facets?.length ? 9 : 12}
        >
          <FilterList
            {...props}
            isEditMode={isEditMode}
            setFacets={(f) => {
              flushSync(() => {
                setFacets(f);
                onTriggerSearch(searchedText || '', f);
              });
            }}
          />

          <div className="search-results-count-sort">
            {/* <SearchDetails text={searchedText} total={totalItems} data={data} /> */}
            <div className="sort-views-wrapper">
              {/* {data.showSortOn && (
                <SortOn
                  querystring={querystring}
                  data={data}
                  isEditMode={isEditMode}
                  sortOn={sortOn}
                  sortOrder={sortOrder}
                  setSortOn={(sortOn) => {
                    flushSync(() => {
                      setSortOn(sortOn);
                      onTriggerSearch(searchedText || '', facets, sortOn);
                    });
                  }}
                  setSortOrder={(sortOrder) => {
                    flushSync(() => {
                      setSortOrder(sortOrder);
                      onTriggerSearch(
                        searchedText || '',
                        facets,
                        sortOn,
                        sortOrder,
                      );
                    });
                  }}
                />
              )} */}
              {data.availableViews && data.availableViews.length > 1 && (
                <ViewSwitcher {...props} />
              )}
            </div>
          </div>
          {children}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default LeftColumnFacets;
